import {Component} from 'react';
import {RadioBox} from './radiobox';
import {FormError} from './form-errors';
import InfoBulle from './info.js';

class FormIndividu extends Component {

	constructor(props){
		super(props);
		if (typeof this.props.dataIndividu === 'undefined'){
			this.state = {
				age : null,
				nationalite: 'FR',
				echelon_bourse :-1,
	            ass_precondition_remplie :false,
	            aah_restriction_substantielle_durable_acces_emploi :false,
	            taux_incapacite :0.3,
	            date_fin_contrat :null,
			};
		}else {
			this.state = this.props.dataIndividu;
			let date =  new Date(Date.parse(this.props.dataIndividu.date_fin_contrat));
		
			let currentMonth = ("0"+(date.getMonth() + 1)).slice(-2); //months are 0-11
			let currentYear = date.getFullYear();
			this.state.date_fin_contrat = currentMonth + '/' + currentYear;
		}

		this.state.validationMessages =[];

		if (this.props.enfant){
			this.state.name = this.props.name;
			this.state.enfant_a_charge = true;
		}else {
			this.state.enfant_a_charge = false;
		}

        this.optionsNationalite = {
            'Française'  : 'FR' ,
            'EEE - UE - Suisse' :'EEE - UE - Suisse' ,
            'Hors UE' :'Hors UE' 
        };
        if (this.props.enfant) {
        	this.state.situations = {
        		"garde_alternee" : {
        			"value" :false,
        			"label" :"En garde alternée"
        		},
        		"etudiant":{
					"value":false,	
					"label":  "Scolarisé·e , Apprenti·e , Étudiant·e"
				},
				
				"chomeur":{
					"value":false,	
					"label":"Inscrit comme demandeur d'emploi"
				},
				"handicap":{
					"value":false,	
					"label":"En situation de handicap"
				},
				
				"aucune_situations":{
					"value":false,
					"label":"Dans aucune de ces situations"
				}
        	};
        }else {

		    this.state.situations = {
				"etudiant":{
					"value":false,	
					"label":  "Etudiant·e, Apprenti·e"
				},
				"retraite":{
					"value":false,	
					"label":"Retraité-e"
				},
				"chomeur":{
					"value":false,	
					"label":"Inscrit comme demandeur d'emploi"
				},
				"handicap":{
					"value":false,	
					"label":"En situation de handicap"
				},
				"inapte_travail":{
					"value":false,
					"label":"Inapte au travail"
				},
				"enceinte":{
					"value":false,	
					"label": "Vous attendez un enfant"
				},
				"aucune_situations":{
					"value":false,	
					"label":"En activité / dans aucune de ces situations"
				}
	    	};
		}
	    if ( typeof this.props.dataIndividu !== "undefined"){ 
		    Object.keys(this.state.situations).forEach((situation)=>{
		    	this.state.situations[situation].value =  this.props.dataIndividu[situation];
			});
		}

	    this.optionsScolarite =[
			{
				label: 'Autre',
				value: 'inconnue'
			},
			{
				label: 'Collège',
				value: 'college'
			},
			{
				label: 'Lycée',
				value: 'lycee'
			}
		];

	}
	/* Handler */
	changeDureeSejourValide = (e)=>{
		const dureeSejourValide = e.target.checked;
        this.setState( (prevState)=> {
            if ( dureeSejourValide  === true) {
                prevState.duree_possession_titre_sejour =   25;
            } else {
            	delete prevState.duree_possession_titre_sejour;
            }
            return prevState;
        });
	}

	handleChangeName = (e)=>{
		const newName = e.target.value;
		this.setState(()=>({name:newName}));
	}

	handleChangeAge = (e)=>{
		const newVal  = e.target.value;
		this.setState( ()=>{
			return {age : parseInt(newVal)};
		});
	}

	handleChangeNationalites = (newVal)=> {
		this.setState( ()=>{
			return {nationalite : newVal} ;
		});
	}

	changeEchelonBourse = (e)=>{
        const newVal = parseInt(e.target.value) ;

        this.setState( () =>{
            return {echelon_bourse : newVal};
        });
    }

    captureTauxIncapacite = (e)=> {
        const tx_incapacite = parseInt(e.target.value);
        if (!isNaN(tx_incapacite)){
            this.setState(()=>{
                return {taux_incapacite:tx_incapacite/10};
            })
        }

    }

    captureScolarite = (e)=>{
    	const scolarite = e.target.value;
        this.setState(()=>{
           return {scolarite:scolarite};
        });
    }

    valideDateFinContrat = ()=>{
    	const formatDate = /^[0-9]{1,2}\/[0-9]{4}$/i;
    	return this.state.date_fin_contrat && this.state.date_fin_contrat.match(formatDate) != null;
    }

    captureDateFinContrat = (e)=> {
    	var newDate = e.target.value;
    	const  months = [
		  'janvier',
		  'février',
		  'mars',
		  'avril',
		  'mai',
		  'juin',
		  'juillet',
		  'aout',
		  'septembre',
		  'octobre',
		  'novembre',
		  'décembre'
		];
    	
    	this.setState( (e)=>{
    		var data = {date_fin_contrat:newDate};
    		if (newDate.toString().length > 4) {
		      let dateYearContrat = newDate.toString().replace(/\//, '-');

		      let eyear = dateYearContrat.split('-')[1] + '-' + dateYearContrat.split('-')[0];

			    data.AnneeFinContrat = parseInt(new Date(eyear).getFullYear());
			    data.moisFinContrat = months[parseInt(new Date(eyear).getMonth())];

			    if (!isNaN(data.AnneeFinContrat)) {
			      data.AnneeMdix = data.AnneeFinContrat - 10;
			  	}
			  
		    }
    		
    		return data;
    	});
    }
    capturePreconditionAss= (val) =>{
    	this.setState(()=>{
    		let newVal = JSON.parse(val);
    		return {ass_precondition_remplie:newVal};
    	});
    }
    captureEnfantCharge =(val )=>{
    	this.setState( {enfant_a_charge: JSON.parse(val)});
    }
    switchRadio = (newValue , modelName)=>{
        this.setState((prevState)=>{
            prevState[modelName] = JSON.parse(newValue);
            return prevState;
        })
    }

	changeSituationCheck = (situation,e)=>{
		this.setState( ({situations,showQuestionAdditionel})=>{
			situations[situation].value =  e.target.checked;

			//situations["aucune_situations"].value = !has_situation;	
			showQuestionAdditionel = situations['chomeur'].value 
                || situations['handicap'].value 
                || situations['etudiant'].value ;

			return {
				situations:situations,
				showQuestionAdditionel:showQuestionAdditionel,
			};
				
		});
    }
    
    noSpecificSituation = ()=>{
    	const noSpecificSituation =  Object.keys(this.state.situations).every( (  situation) =>{
    		return this.state.situations[situation].value == false;
    	});

    	return noSpecificSituation ;
    }

    addErrorMessage = (message)=>{
    	this.setState(({validationMessages})=>{
    		if (!validationMessages.includes(message)){
    			validationMessages.push(message);
    		}
    		return {validationMessages:validationMessages}
    	});

    }

    getBirthDateFromAge = function (age) {
	  const today = new Date();
	  return new Date(today.getFullYear() - age, today.getMonth(), today.getDate() - 1);
	};

    validation = () => {
    	/**/

    	let passedValidation = true;
    	/* Reset validation messages*/
    	this.setState(()=>({validationMessages:[]}));

    	if ( ["" , false , undefined , NaN,null ].includes (this.state.age ) || this.state.age < 0 ) {
    		passedValidation=false;
    		let message = 'Veuillez insérer un age valide.';
    		this.addErrorMessage(message);
    	}

    	if ( this.noSpecificSituation()) {
    		passedValidation = false;
    		let message = "Veuillez renseigner votre situation";
    		this.addErrorMessage(message);
    	}



    	if ( passedValidation) {
    		let data ={...{},...this.state};
    		// synchronise donnée de l'invidivu avec situations .
            for ( let situation in this.state.situations){
                data[situation] = this.state.situations[situation].value;
                if ( situation === "etudiant" && data[situation]) {
                    data.activite = 'etudiant';
                } else if (situation === "retraite" && data[situation]) {
                    data.activite = 'retraite';
                } else if (situation === "chomeur" && data[situation]) {
                    data.activite = 'chomeur';
                } else if (situation === "inapte_travail" && data[situation]){
                    data.activite = 'inactif';
                }
            }
            if (this.props.enfant &&( this.state.name === '' || typeof this.state.name === 'undefined') ){
            	data.name = this.props.name;
            }

            if ( this.state.situations.chomeur.value === true && !this.valideDateFinContrat()) {
	    		data.date_fin_contrat = new Date();
	    	}

	    	data.date_naissance = this.getBirthDateFromAge(data.age);

            let date = data.date_fin_contrat == undefined || !this.valideDateFinContrat() ? new Date() : new Date(data.date_fin_contrat.replace('/','/01/'));

            data.date_fin_contrat = new Date(date - (3600*1000*24));


    		delete data.validationMessages;
    		delete data.situations;
    		delete data.AnneeFinContrat;
    		delete data.AnneeMdix;
    		delete data.moisFinContrat;
    		delete data.showQuestionAdditionel;

    		this.props.saveData(data);
    		document.getElementById('anchor').scrollIntoView({behavior:'smooth'}) ;
    	}
    }

	/* Renderer */
	render() {
		var pourcentageHandicap ;
	    if (this.state.taux_incapacite <0.5){
	    	pourcentageHandicap = "Moins de 50 %";
	    } else if ( this.state.taux_incapacite >= 0.5 && this.state.taux_incapacite<= 0.8) {
	    	pourcentageHandicap = "Entre 50% et 80%";
	    }else if (this.state.taux_incapacite >0.8){
	    	pourcentageHandicap = "Plus de 80%";
	    }
		const listSituation = [];
    	for ( let situation in this.state.situations){
    		listSituation.push({...this.state.situations[situation] , ...{name:situation}});
    	}
    	const messageInfo = <p>Si votre enfant est âgé de moins de 1 an, indiquez simplement 1 an dans la case ci-dessous.</p>;

		return <div className="formulaire-personne">
			{(this.props.enfant) ?
				<div>
					<label><h3>Prénom</h3></label>
					
					<input 
						type="text"
						name="name" 
						id="name"
						placeholder={this.props.name + ' (faculatif)'}
						onChange={this.handleChangeName}
						/>
				</div>: ''
			}
			<div>
				<label><h3> Age {this.props.enfant ? <InfoBulle message={messageInfo}/> :''}</h3></label>
				<input type="number" 
					id="age"
					name="age"
					value={this.state.age} 
					onChange={this.handleChangeAge} />
			</div>

			<div className="question" >
				<RadioBox 
				 	name="zone"
		            options = {this.optionsNationalite}
		            handler= {this.handleChangeNationalites}
		            defaultValue= {this.state.nationalite}
				>
		          <h3 >Nationalité</h3>
		        </RadioBox>

		          
		          { (this.state.nationalite !== "FR" )?(
	                 <div className="question"  >
	                    <input  id="dSejour" defaultChecked={true} onChange={this.changeDureeSejourValide} type="checkbox"/>
	                    <label className="custom-control-label" htmlFor="dSejour" >
	                        Résidant en France plus de 9 mois par an
	                    </label>
	                 </div>
	             ): ''}
		    </div>

		    <div className="question">
				<div className="situation-individu">
					<div className="situation-checkbox">
						<div className="situation-label">
						       <h3>Situation spécifique :</h3>
						       <span className="indication-text">(plusieurs choix possibles)</span>
						</div>
						{listSituation.map(  (situation)=>{
							return <div className="custom-checkbox" key={situation.name}>
								<label className="custom-control" htmlFor={situation.name} >
							       <div className="checkbox-container">
							            <input type="checkbox"  
							            	value={situation.name}
							            	checked = {this.state.situations[situation.name].value}
							            	onChange = {(e)=>{this.changeSituationCheck(situation.name,e)}}
							            	className ="custom-control-input"
							            	id={situation.name}/>
							            <span className="checkmark"></span>
							       </div>
							       <span className="label">{situation.label}</span>
							    </label>
							</div>;})
						}	
					</div>
					<div className={ 'situations-question ' + (this.state.showQuestionAdditionel ? 'slide-in' : 'fade-out')}>
		                    {(this.state.situations.etudiant.value === true)?
		                        <div className = "fade-in">
		                           <h3><label htmlFor="echelon_bourse">À quel échelon est-il(elle) boursier ?</label></h3>
		                           <input type="range"
		                                id="echelon_bourse"
		                                name="echelon_bourse"
		                                min="-1"
		                                max="10"
		                                value = {this.state.echelon_bourse}
		                                onChange={this.changeEchelonBourse}
		                            /><br/>
		                            {(this.state.echelon_bourse >=0) ?
		                                <small>Boursier échelon {this.state.echelon_bourse}</small>:
		                                <small>Non Boursier</small>
		                            }

		                        </div>
		                        :''
		                    }
		                    {(this.state.situations.etudiant.value === true && this.props.enfant)?
		                    	<div className = "fade-in">
		                        	<RadioBox name="ass_precondition_remplie"
		                    			options={{"Oui":true, "Non":false}}
		                    			defaultValue={this.state.enfant_a_charge}
		                    			modelName="enfant_a_charge"
		                    			handler={this.captureEnfantCharge}
		                    		>
		                    			<h3>Figure-t-il/elle sur votre dernière déclaration d'impôt sur le revenu ?</h3>
		                    		</RadioBox>
		                        </div>
		                        :''

		                    }

		                    { (!isNaN(this.state.age) && (this.state.age < 22 && this.state.age>2 ) && this.state.situations.etudiant.value)? 
		                    	<div className="fade-in">
		                    		<h3><label htmlFor="scolarite">Où sera-t-il/elle scolarisé·e à la rentrée prochaine&nbsp;? </label></h3>
		                    		<select name="scolarite" value={this.state.scolarite} onChange={this.captureScolarite} >
		                    			<option  value="" selected disabled hidden  >Choisissez le type d'établissement</option>
		                    			{ this.optionsScolarite.map( (option)=>(
		                    				<option value={option.value} >{option.label}</option>
		                    			))}
		                    		</select>
		                    	</div>:''
		                    }

		                    { (this.state.situations.chomeur.value === true) ?
		                        <div className ={'hidden-question '+ this.state.situations.chomeur.value ? 'fade-in' : 'fade-out'}>
		                            <h3>Quand s'est terminé son dernier contrat de travail ? </h3> 
		                            <small>(Si il/elle n'a jamais eu de contrat de travail, laissez ce champ vide)</small><br/>
		                            <input type="text" placeholder="MM/AAAA" onChange={this.captureDateFinContrat} />
		                        </div>
		                        :''
		                    }
		                    { (this.state.situations.chomeur.value === true && this.valideDateFinContrat() && !isNaN(this.state.AnneeFinContrat)  ) ?
		                    	<div className="fade-in">
		                    		
		                    		<RadioBox name="ass_precondition_remplie"
		                    			options={{"Oui":true, "Non":false}}
		                    			defaultValue={this.state.ass_precondition_remplie}
		                    			modelName="ass_precondition_remplie"
		                    			handler={this.capturePreconditionAss}
		                    		>
		                    			<h3>Avez-vous travaillé au moins 5 ans entre {this.state.moisFinContrat} {this.state.AnneeMdix} et {this.state.moisFinContrat} {this.state.AnneeFinContrat}&nbsp;?</h3>
		                    		</RadioBox>
		                    	</div>: ''

		                    }
		                    { (this.state.situations.handicap.value === true && !this.props.enfant) ?
		                        <>
		                            <div className ="fade-in">
		                               <h3>Votre taux d'incapacité</h3>
		                               <small>(Evalué par votre MDPH)</small>
		                               <input type="range"
		                                    id="taux_incapacite"
		                                    name="taux_incapacite"
		                                    min="1"
		                                    max="9"
		                                    value={this.state.taux_incapacite * 10}
		                                    onChange={this.captureTauxIncapacite}
		                                    />
		                                <small>{pourcentageHandicap}</small>
		                            </div>
		                            
		                            <div className = { 
		                                (0.5 <= this.state.taux_incapacite && this.state.taux_incapacite < 0.8 )?
		                                "fade-in" : "fade-out"
		                            }>
		                                
		                                <RadioBox name="cdaph"
		                                    options={{"Oui":true , "Non":false}}
		                                    defaultValue= {this.state.aah_restriction_substantielle_durable_acces_emploi}
		                                    modelName="aah_restriction_substantielle_durable_acces_emploi"
		                                    handler={this.switchRadio}
		                                >
		                                    <h3>Avez-vous une restriction substantielle et durable d'accès à l'emploi reconnue par la CDAPH ?</h3>
		                                    <small>(Attention, cette restriction est différente de la reconnaissance de la qualité de travailleur handicapé.)</small>
		                                </RadioBox>
		                            </div>
		                        </>
		                        :''
		                    }
					</div>
				</div>
			</div>
			<div className="error-container">
				<FormError errors={this.state.validationMessages}/>
			</div>
			<button onClick={this.validation}> Enregistrer </button>
		</div>;
	}
}

export default FormIndividu;
